// Mesmos limites do painel (AssistantAgentPreview): imagem de até 10 MB. SVG fica de fora porque
// pode carregar script; o painel aceita image/* sem essa restrição.
export const IMAGE_MAX_BYTES = 10 * 1024 * 1024;
const FALLBACK_CAPTION = "Foto enviada pelo cliente.";
const CAPTION_MAX_CHARS = 800;

export const IMAGE_TYPE_MESSAGE = "Escolha um arquivo de imagem.";
export const IMAGE_SIZE_MESSAGE = "A imagem deve ter no máximo 10 MB.";

// Devolve a mensagem de erro para o usuário, ou null se a foto pode ser enviada.
export function validateImageFile(file: { type: string; size: number }): string | null {
  if (!file.type.startsWith("image/") || file.type === "image/svg+xml") return IMAGE_TYPE_MESSAGE;
  if (file.size > IMAGE_MAX_BYTES) return IMAGE_SIZE_MESSAGE;
  return null;
}

// Legenda que a visão devolve, limitada como no painel.
export function captionFrom(value: string): string {
  return value.trim().slice(0, CAPTION_MAX_CHARS) || FALLBACK_CAPTION;
}
